import { c as _c } from "react/compiler-runtime";
import { Theme, ThemeContext } from '@emotion/react';
import { faCalendar, faEnvelope, faMapMarker, faPhone } from '@fortawesome/pro-regular-svg-icons';
import Tippy from 'shared/tooltip';
import deepEqual from 'fast-deep-equal';
import { DateTime } from 'luxon';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link as ReachLink } from 'react-router-dom';
import Button from 'shared/button';
import Callout from 'shared/callout';
import DropdownSelect from 'shared/dropdown-select';
import { Box, Flex, Grid } from 'shared/grid';
import IconWrapper from 'shared/icon-wrapper';
import { fetchService } from 'shared/redux/services/actions';
import settings from 'shared/settings';
import { CustomElement } from 'shared/slate-shared/custom-types';
import RenderSlate from 'shared/slate-shared/render';
import { CroppedText, Heading, Link, Text } from 'shared/typography';
import { getBookingUrl, getVideoCallLink, getVideoCallUrl, statusToColorScale } from 'shared/utils/booking';
import { useAppDispatch, useAppSelector } from '../../store';
import { BorderBox } from '../shared';
import { useCantCancelBookingReason } from './hooks';
const ContactDetails = t0 => {
  const $ = _c(7);
  const {
    location
  } = t0;
  let t1;
  if ($[0] !== location.email) {
    t1 = location.email && <Flex as="a" href={`mailto:${location.email}`} alignItems="center" fontSize={2}><IconWrapper icon={faEnvelope} size={1} mr={2} /> {location.email}</Flex>;
    $[0] = location.email;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== location.tel) {
    t2 = location.tel && <Flex as="a" href={`tel:${location.tel}`} alignItems="center" fontSize={2}><IconWrapper icon={faPhone} size={1} mr={2} /> {location.tel}</Flex>;
    $[2] = location.tel;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <>{t1}{t2}</>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
const EMPTY_VALUE: CustomElement[] = [{
  type: 'paragraph',
  children: [{
    text: ''
  }]
}];
const isSlateBlank = (value: any[]) => {
  if (!value) {
    return true;
  }
  return deepEqual(value, EMPTY_VALUE);
};
export default function BookingDefaultView(t0) {
  const $ = _c(115);
  const {
    booking,
    location,
    canCancel,
    isOwner,
    setShowCancelModal
  } = t0;
  const dispatch = useAppDispatch();
  const business = useAppSelector(_temp);
  useAppSelector(_temp2);
  const serviceData = useAppSelector(_temp3);
  let t1;
  if ($[0] !== booking.services) {
    t1 = (booking?.services || []).map(_temp4).join(" + ");
    $[0] = booking.services;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const serviceName = t1;
  const offsite = booking?.services.some(t2 => {
    const {
      service_id
    } = t2;
    return serviceData[service_id]?.offsite !== "on_premises";
  });
  const timezone = offsite && booking.client_timezone || location.timezone;
  const [timeToStart, setTimeToStart] = React.useState("");
  let t3;
  if ($[2] !== booking.services) {
    t3 = booking.services.map(_temp5).sort(_temp6);
    $[2] = booking.services;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const earliestStart = t3[0];
  booking.services.map(_temp7).sort(_temp8);
  let t4;
  let t5;
  if ($[4] !== booking.services || $[5] !== dispatch || $[6] !== serviceData) {
    t4 = () => {
      booking.services.forEach(t6 => {
        const {
          service_id: service_id_0
        } = t6;
        if (service_id_0 && !serviceData[service_id_0]) {
          dispatch(fetchService(service_id_0));
        }
      });
    };
    t5 = [booking.services, dispatch, serviceData];
    $[4] = booking.services;
    $[5] = dispatch;
    $[6] = serviceData;
    $[7] = t4;
    $[8] = t5;
  } else {
    t4 = $[7];
    t5 = $[8];
  }
  React.useEffect(t4, t5);
  let t6;
  let t7;
  if ($[9] !== earliestStart) {
    t6 = () => {
      const set = () => {
        const tts = DateTime.fromISO(earliestStart).toRelative();
        setTimeToStart(tts);
      };
      const id = setInterval(set, 60000);
      set();
      return () => clearInterval(id);
    };
    t7 = [earliestStart];
    $[9] = earliestStart;
    $[10] = t6;
    $[11] = t7;
  } else {
    t6 = $[10];
    t7 = $[11];
  }
  React.useEffect(t6, t7);
  const startTime = DateTime.fromISO(earliestStart, {
    zone: timezone
  }).toFormat("t");
  const startDate = DateTime.fromISO(earliestStart, {
    zone: timezone
  }).toFormat("DDDD");
  const startDateTime = DateTime.fromISO(earliestStart, {
    zone: timezone
  }).toFormat("DDDD 'at' t (ZZZZ)");
  const t8 = location.name || "[removed location]";
  let t9;
  if ($[12] !== serviceName || $[13] !== startDate || $[14] !== startTime || $[15] !== t8) {
    t9 = {
      startTime,
      startDate,
      serviceName,
      locationName: t8
    };
    $[12] = serviceName;
    $[13] = startDate;
    $[14] = startTime;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  const bookingMsgValues = t9;
  let t10;
  if ($[17] !== booking.services || $[18] !== booking.third_party_video_call_url || $[19] !== booking.video_call_enabled || $[20] !== serviceData) {
    t10 = !!booking.third_party_video_call_url || booking.video_call_enabled || booking.services.map(t11 => {
      const {
        service_id: service_id_1
      } = t11;
      return serviceData[service_id_1];
    }).filter(Boolean).some(_temp9);
    $[17] = booking.services;
    $[18] = booking.third_party_video_call_url;
    $[19] = booking.video_call_enabled;
    $[20] = serviceData;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  const hasVideoCall = t10;
  let t11;
  if ($[22] !== booking.services || $[23] !== serviceData) {
    let t12;
    if ($[25] !== serviceData) {
      t12 = t13 => {
        const {
          service_id: service_id_2
        } = t13;
        return serviceData[service_id_2];
      };
      $[25] = serviceData;
      $[26] = t12;
    } else {
      t12 = $[26];
    }
    t11 = booking.services.map(t12).filter(Boolean).some(_temp0);
    $[22] = booking.services;
    $[23] = serviceData;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  const hasOnsite = t11;
  const showLocation = !location.is_virtual && hasOnsite;
  let t12;
  if ($[27] !== booking) {
    t12 = getVideoCallLink(booking);
    $[27] = booking;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  const videoCallLink = t12;
  let t13;
  if ($[29] !== bookingMsgValues) {
    t13 = {
      confirmed: <FormattedMessage id="Public.BookingPage.confirmedBookingDesciption" defaultMessage="Your {serviceName} booking for {startTime} on {startDate} was confirmed." values={bookingMsgValues} />,
      no_show: <FormattedMessage id="Public.BookingPage.noShowBookingDesciption" defaultMessage="It was noted that you did not show up for your {serviceName} booking that was scheduled for {startTime} on {startDate}." values={bookingMsgValues} />,
      cancelled: <FormattedMessage id="Public.BookingPage.cancelledBookingDesciption" defaultMessage="Your {serviceName} booking for {startTime} on {startDate} was cancelled." values={bookingMsgValues} />,
      requested: <FormattedMessage id="Public.BookingPage.requestedBookingDesciption" defaultMessage="Your {serviceName} booking for {startTime} on {startDate} is pending approval." values={bookingMsgValues} />,
      pencilled_in: <FormattedMessage id="Public.BookingPage.pencilledInBookingDesciption" defaultMessage="Your {serviceName} booking for {startTime} on {startDate} has been pencilled in." values={bookingMsgValues} />,
      awaiting_payment: <FormattedMessage id="Public.BookingPage.awaitingPaymentBookingDesciption" defaultMessage="Your {serviceName} booking for {startTime} on {startDate} is awaiting payment." values={bookingMsgValues} />,
      denied: <FormattedMessage id="Public.BookingPage.deniedBookingDesciption" defaultMessage="Your {serviceName} booking for {startTime} on {startDate} was declined." values={bookingMsgValues} />
    };
    $[29] = bookingMsgValues;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  const statusToMsg = t13;
  const theme = React.useContext(ThemeContext as any);
  let t14;
  if ($[31] !== business.feature_flags) {
    t14 = business?.feature_flags || [];
    $[31] = business.feature_flags;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  const featureFlags = t14;
  let t15;
  if ($[33] !== featureFlags) {
    t15 = featureFlags.includes("video_calls");
    $[33] = featureFlags;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  const videoCallsEnabled = t15;
  const locationData = useAppSelector(_temp1);
  const businessData = useAppSelector(_temp10);
  const business_0 = businessData[booking.business_id];
  const location_0 = locationData[booking.location_id];
  let urls;
  if ($[35] !== booking.id || $[36] !== booking.services || $[37] !== booking.third_party_video_call_url || $[38] !== booking.video_call_enabled || $[39] !== business_0 || $[40] !== location_0 || $[41] !== serviceData) {
    urls = {
      google: "",
      outlook: "",
      yahoo: ""
    };
    booking.services.forEach(service => {
      let description;
      let locationAddress;
      const serviceStart = DateTime.fromISO(service.start, {
        zone: "UTC"
      });
      const serviceEnd = DateTime.fromISO(service.end, {
        zone: "UTC"
      });
      let serviceName_0 = service.service_name || "Custom";
      serviceName_0 = serviceName_0 + ` (${business_0.name})`;
      const serviceType = serviceData[service.service_id]?.type;
      const bookingLink = getBookingUrl(booking.id);
      if (serviceType == "video" || booking.third_party_video_call_url || booking.video_call_enabled) {
        const videoLink = getVideoCallUrl(booking.id);
        locationAddress = videoLink;
        description = `ℹ️  ${bookingLink}\n\n📍  ${videoLink}`;
      } else {
        if (serviceType === "on_premises" && location_0 && !location_0.is_virtual) {
          locationAddress = [...location_0.street_address.split(","), location_0.city, location_0.postal_code, location_0.province].filter(Boolean).join(", ");
          const gps = location_0?.gps?.[0] && location_0?.gps?.[1] ? location_0.gps : null;
          const mapLink = gps ? `\n\n📍 https://maps.google.com/maps?&z=16&q=${gps[0]}+${gps[1]}&ll=${gps[0]}+${gps[1]}` : "";
          description = location_0 ? `ℹ️  ${bookingLink}${mapLink}` : "";
        } else {
          description = `ℹ️  ${bookingLink}`;
          locationAddress = "";
        }
      }
      const title = serviceName_0;
      description = encodeURIComponent(description);
      const startDatetimeGoogleYahoo = serviceStart.toFormat("yyyyMMdd'T'HHmmss") + "Z";
      const endDatetimeGoogleYahoo = serviceEnd.toFormat("yyyyMMdd'T'HHmmss") + "Z";
      const startDatetimeOutlook = serviceStart.toFormat("yyyy'-'MM'-'dd'T'HH':'mm':'ss") + "Z";
      const endDatetimeOutlook = serviceEnd.toFormat("yyyy'-'MM'-'dd'T'HH':'mm':'ss") + "Z";
      urls.google = `http://www.google.com/calendar/event?action=TEMPLATE&dates=${startDatetimeGoogleYahoo}/${endDatetimeGoogleYahoo}&text=${title}&location=${locationAddress}&details=${description}`;
      urls.outlook = `https://outlook.live.com/calendar/action/compose?rru=addevent&startdt=${startDatetimeOutlook}&enddt=${endDatetimeOutlook}&subject=${title}&body=${description}&location=${locationAddress}`;
      urls.yahoo = `https://calendar.yahoo.com/?v=60&TITLE=${title}&ST=${startDatetimeGoogleYahoo}&ET=${endDatetimeGoogleYahoo}&DESC=${description}&in_loc=${locationAddress}`;
    });
    $[35] = booking.id;
    $[36] = booking.services;
    $[37] = booking.third_party_video_call_url;
    $[38] = booking.video_call_enabled;
    $[39] = business_0;
    $[40] = location_0;
    $[41] = serviceData;
    $[42] = urls;
  } else {
    urls = $[42];
  }
  const calendarUrls = urls;
  const cantCancelReason = useCantCancelBookingReason(canCancel, business?.settings.disable_changes, booking?.services, isOwner);
  let t16;
  if ($[43] !== booking.status || $[44] !== theme) {
    t16 = statusToColorScale(theme, booking.status);
    $[43] = booking.status;
    $[44] = theme;
    $[45] = t16;
  } else {
    t16 = $[45];
  }
  let t17;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = [3, 0];
    $[46] = t17;
  } else {
    t17 = $[46];
  }
  const t18 = statusToMsg[booking.status];
  let t19;
  if ($[47] !== t18) {
    t19 = <CroppedText>{t18}</CroppedText>;
    $[47] = t18;
    $[48] = t19;
  } else {
    t19 = $[48];
  }
  let t20;
  if ($[49] !== t16 || $[50] !== t19) {
    t20 = <Callout color={t16} mx={t17}>{t19}</Callout>;
    $[49] = t16;
    $[50] = t19;
    $[51] = t20;
  } else {
    t20 = $[51];
  }
  let t21;
  let t22;
  if ($[52] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = ["\n          'content'\n          'sidepanel'\n        ", "\n          'content sidepanel'\n        "];
    t22 = ["1fr", "1fr 300px"];
    $[52] = t21;
    $[53] = t22;
  } else {
    t21 = $[52];
    t22 = $[53];
  }
  let t23;
  if ($[54] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = [0, 6];
    $[54] = t23;
  } else {
    t23 = $[54];
  }
  let t24;
  if ($[55] !== serviceName) {
    t24 = <Heading>{serviceName}</Heading>;
    $[55] = serviceName;
    $[56] = t24;
  } else {
    t24 = $[56];
  }
  let t25;
  if ($[57] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <IconWrapper icon={faCalendar} size={1} mr={2} flexShrink={0} />;
    $[57] = t25;
  } else {
    t25 = $[57];
  }
  let t26;
  if ($[58] !== startDateTime) {
    t26 = <Flex alignItems="center">{t25}<Text>{startDateTime}</Text></Flex>;
    $[58] = startDateTime;
    $[59] = t26;
  } else {
    t26 = $[59];
  }
  let t27;
  if ($[60] !== location.city || $[61] !== location.directions || $[62] !== location.gps || $[63] !== location.postal_code || $[64] !== location.province || $[65] !== location.street_address || $[66] !== showLocation) {
    t27 = showLocation && <><Flex as="a" href={`https://maps.google.com/maps?&z=16&q=${location.gps[0]}+${location.gps[1]}&ll=${location.gps[0]}+${location.gps[1]}`} alignItems="flex-start"><IconWrapper icon={faMapMarker} size={1} mr={2} flexShrink={0} /><Text>{[...(location.street_address || "").split("\n"), location.city, location.postal_code, location.province].map(_temp11)}{!isSlateBlank(location.directions) && <><br /><Text fontWeight="heading"><FormattedMessage id="Public.BookingPage.directions" defaultMessage="Directions" /></Text><RenderSlate value={location.directions} /></>}</Text></Flex></>;
    $[60] = location.city;
    $[61] = location.directions;
    $[62] = location.gps;
    $[63] = location.postal_code;
    $[64] = location.province;
    $[65] = location.street_address;
    $[66] = showLocation;
    $[67] = t27;
  } else {
    t27 = $[67];
  }
  let t28;
  if ($[68] !== location) {
    t28 = <ContactDetails location={location} />;
    $[68] = location;
    $[69] = t28;
  } else {
    t28 = $[69];
  }
  let t29;
  if ($[70] !== t24 || $[71] !== t26 || $[72] !== t27 || $[73] !== t28) {
    t29 = <BorderBox pt={t23} gridArea="content"><Grid gridGap={4}>{t24}{t26}{t27}{t28}</Grid></BorderBox>;
    $[70] = t24;
    $[71] = t26;
    $[72] = t27;
    $[73] = t28;
    $[74] = t29;
  } else {
    t29 = $[74];
  }
  let t30;
  if ($[75] !== booking.status || $[76] !== hasVideoCall || $[77] !== timeToStart || $[78] !== videoCallLink || $[79] !== videoCallsEnabled) {
    t30 = booking.status === "confirmed" && videoCallsEnabled && hasVideoCall && <Button as="a" color="success" target="_blank" rel="nofollow" href={videoCallLink}><FormattedMessage id="Public.BookingPage.joinVideoCall" defaultMessage="Join video call" values={{
        timeToStart
      }} /></Button>;
    $[75] = booking.status;
    $[76] = hasVideoCall;
    $[77] = timeToStart;
    $[78] = videoCallLink;
    $[79] = videoCallsEnabled;
    $[80] = t30;
  } else {
    t30 = $[80];
  }
  let t31;
  if ($[81] !== booking.id || $[82] !== booking.status || $[83] !== calendarUrls) {
    t31 = booking.status === "confirmed" && <><DropdownSelect value={null} items={[{
        label: "Add to your calendar (iCal)",
        value: "ics"
      }, {
        label: "Add to Google calendar",
        value: "google"
      }, {
        label: "Add to Outlook calendar",
        value: "outlook"
      }, {
        label: "Add to Yahoo calendar",
        value: "yahoo"
      }]} itemToString={_temp12} onChange={v_0 => {
        if (v_0 == "ics") {
          window.open(`${settings.api2Root}/ical/b/${booking.id}/booking.ics`);
        } else {
          if (v_0 == "google") {
            window.open(calendarUrls.google);
          } else {
            if (v_0 == "outlook") {
              window.open(calendarUrls.outlook);
            } else {
              if (v_0 == "yahoo") {
                window.open(calendarUrls.yahoo);
              }
            }
          }
        }
      }} renderToggle={_temp13} /></>;
    $[81] = booking.id;
    $[82] = booking.status;
    $[83] = calendarUrls;
    $[84] = t31;
  } else {
    t31 = $[84];
  }
  let t32;
  if ($[85] !== booking || $[86] !== business.online) {
    t32 = business.online && <Button as={ReachLink} variant="outlined" to={"/" + (booking ? `?lid=${booking.location_id}` : "")}><FormattedMessage id="Public.BookingPage.makeAnotherBooking" defaultMessage="Make another booking" /></Button>;
    $[85] = booking;
    $[86] = business.online;
    $[87] = t32;
  } else {
    t32 = $[87];
  }
  const t33 = canCancel || booking.status == "cancelled";
  let t34;
  if ($[88] !== setShowCancelModal) {
    t34 = () => setShowCancelModal(true);
    $[88] = setShowCancelModal;
    $[89] = t34;
  } else {
    t34 = $[89];
  }
  const t35 = !canCancel;
  let t36;
  if ($[90] === Symbol.for("react.memo_cache_sentinel")) {
    t36 = <FormattedMessage id="Cancel booking" defaultMessage="Cancel booking" />;
    $[90] = t36;
  } else {
    t36 = $[90];
  }
  let t37;
  if ($[91] !== t34 || $[92] !== t35) {
    t37 = <Box><Button color="alert" variant="outlined" onClick={t34} width="100%" disabled={t35}>{t36}</Button></Box>;
    $[91] = t34;
    $[92] = t35;
    $[93] = t37;
  } else {
    t37 = $[93];
  }
  let t38;
  if ($[94] !== cantCancelReason || $[95] !== t33 || $[96] !== t37) {
    t38 = <Tippy disabled={t33} content={cantCancelReason}>{t37}</Tippy>;
    $[94] = cantCancelReason;
    $[95] = t33;
    $[96] = t37;
    $[97] = t38;
  } else {
    t38 = $[97];
  }
  let t39;
  if ($[98] !== t30 || $[99] !== t31 || $[100] !== t32 || $[101] !== t38) {
    t39 = <Grid p={4}>{t30}{t31}{t32}{t38}</Grid>;
    $[98] = t30;
    $[99] = t31;
    $[100] = t32;
    $[101] = t38;
    $[102] = t39;
  } else {
    t39 = $[102];
  }
  let t40;
  if ($[103] !== location.gps || $[104] !== showLocation) {
    t40 = showLocation && <Box px={4} py={4} borderBottomWidth="1px" borderBottomStyle="solid" borderBottomColor="gray.1"><Link rel="noopener noreferrer" target="_blank" href={`https://maps.google.com/maps?&z=16&q=${location.gps[0]}+${location.gps[1]}&ll=${location.gps[0]}+${location.gps[1]}`}><Box as="img" alt="map" width="100%" src={`https://maps.google.com/maps/api/staticmap?key=${__GOOGLE_MAPS_KEY__}&center=${location.gps[0]},${location.gps[1]}&zoom=14&size=300x300&sensor=false&markers=color:red|${location.gps[0]},${location.gps[1]}`} /></Link></Box>;
    $[103] = location.gps;
    $[104] = showLocation;
    $[105] = t40;
  } else {
    t40 = $[105];
  }
  let t41;
  if ($[106] !== t39 || $[107] !== t40) {
    t41 = <Box gridArea="sidepanel"><BorderBox as={Flex} flexDirection="column" p={0}>{t39}{t40}</BorderBox></Box>;
    $[106] = t39;
    $[107] = t40;
    $[108] = t41;
  } else {
    t41 = $[108];
  }
  let t42;
  if ($[109] !== t29 || $[110] !== t41) {
    t42 = <Grid gridTemplateAreas={t21} gridTemplateColumns={t22}>{t29}{t41}</Grid>;
    $[109] = t29;
    $[110] = t41;
    $[111] = t42;
  } else {
    t42 = $[111];
  }
  let t43;
  if ($[112] !== t20 || $[113] !== t42) {
    t43 = <Box><Grid>{t20}{t42}</Grid></Box>;
    $[112] = t20;
    $[113] = t42;
    $[114] = t43;
  } else {
    t43 = $[114];
  }
  return t43;
}
function _temp13(props) {
  return <Button {...props} variant="outlined" data-sentry-element="Button" data-sentry-component="_temp13" data-sentry-source-file="view.tsx">Add to your calendar</Button>;
}
function _temp12() {
  return "";
}
function _temp11(line, idx) {
  return <Text key={idx} data-sentry-element="Text" data-sentry-component="_temp11" data-sentry-source-file="view.tsx">{line}</Text>;
}
function _temp10(state_3) {
  return state_3.businesses.data;
}
function _temp1(state_2) {
  return state_2.locations.data;
}
function _temp0(s_2) {
  return s_2.type === "on_premises";
}
function _temp9(s_1) {
  return s_1.type === "video";
}
function _temp8(a_0, b_0) {
  return a_0 < b_0 ? 1 : -1;
}
function _temp7(s_0) {
  return s_0.end;
}
function _temp6(a, b) {
  return a < b ? -1 : 1;
}
function _temp5(s) {
  return s.start;
}
function _temp4(v) {
  return v.service_name || "";
}
function _temp3(state_1) {
  return state_1.services.data;
}
function _temp2(state_0) {
  return state_0.userPreferences.language;
}
function _temp(state) {
  return state.businesses.data[state.public.businessId];
}